import { useEffect, useState } from "react";
import { DollarSign, TrendingUp } from "lucide-react";
import api from "@/lib/api";

export default function AdminTokenRevenue() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/token-revenue").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const t = data.totals;
  const usd = (n) => `$${Number(n || 0).toFixed(2)}`;

  return (
    <div className="border border-slate-200 p-5 mb-8" data-testid="admin-token-revenue">
      <h3 className="font-bold text-sm uppercase tracking-wide text-slate-500 mb-4 flex items-center gap-2">
        <DollarSign className="w-4 h-4" /> Venituri Tokenuri (OXO)
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
        <Metric label="Încasări totale" value={usd(t.total_paid)} testid="rev-total-paid" />
        <Metric label="Cost infrastructură" value={usd(t.estimated_token_cost)} muted testid="rev-infra" />
        <Metric label="Comision OXO (profit)" value={usd(t.oxo_commission)} accent testid="rev-commission" />
        <Metric label="Credite vândute" value={t.credits_sold} testid="rev-credits" />
      </div>
      <div className="text-xs text-slate-500 mb-2 flex items-center gap-1"><TrendingUp className="w-3.5 h-3.5" /> Pe pachet · {t.orders} comenzi plătite</div>
      <div className="divide-y divide-slate-100 border border-slate-100">
        {Object.entries(data.by_pack).map(([k, p]) => (
          <div key={k} className="flex items-center justify-between px-3 py-2 text-sm" data-testid={`rev-pack-${k}`}>
            <span className="font-semibold">{p.label}</span>
            <span className="text-slate-500">{p.orders} vânz. · {usd(p.total_paid)} · profit <b className="text-emerald-700">{usd(p.oxo_commission)}</b></span>
          </div>
        ))}
      </div>
    </div>
  );
}

const Metric = ({ label, value, accent, muted, testid }) => (
  <div data-testid={testid}>
    <div className={`text-2xl font-black tracking-tight ${accent ? "text-emerald-700" : muted ? "text-slate-400" : "text-slate-900"}`}>{value}</div>
    <div className="text-[10px] uppercase tracking-wide text-slate-400 leading-tight mt-0.5">{label}</div>
  </div>
);
